module.exports = __webpack_public_path__ + "img/2.340c02d9.png";